module.exports = __webpack_public_path__ + "img/Dantam Hair 56.73bebd7f.jpg";